'use strict';
var populationElements = document.querySelectorAll('.population');
var totalPopulation = 0;
populationElements.forEach(function(element) {
    var numberValue = Number(element.textContent.replace(/,/g, ''));
    if (!isNaN(numberValue)) totalPopulation += numberValue;
});
var averagePopulation = Math.round(totalPopulation / populationElements.length);
document.querySelector('.total-population').textContent = totalPopulation.toLocaleString('en-US');
document.querySelector('.average-population').textContent = averagePopulation.toLocaleString('en-US');

//# sourceMappingURL=js_get_data_DOM.494a4cec.js.map
